import { defineStore } from 'pinia';

export const useCategoryStore = defineStore('WhatsAppCategoriesStore', {
	state: () => ({
        isOpenCategoryDialog: false,
        isOpenAssignCategoriesWhatsDialog: false,
        hasFilters: false,
	}),
	actions: {
	},
});
